import {User} from "../api";

export * from './backend'
export * from './downloader'
export * from './isMobileDevice'

export const createUUID = () => {
  let dt = new Date().getTime();
  const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(
      /[xy]/g,
      function (c) {
        const r = (dt + Math.random() * 16) % 16 | 0;
        dt = Math.floor(dt / 16)
        return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16)
      }
  );
  return uuid
}

// localStorage key for the display's stable machine id. Dedicated (not the
// redux-persist `easeon_token` blob) so the id can be read SYNCHRONOUSLY at
// first render, before redux-persist's async rehydration runs.
export const MACHINE_ID_STORAGE_KEY = 'easeon_machine_id'

/**
 * Resolve the display's machine id synchronously, creating and persisting one
 * on first use. The realtime WebSocket URL is keyed on this id, so it MUST be
 * stable from the very first render: generating it in a post-render effect
 * races redux-persist's asynchronous rehydration of the `easeon_token` slice,
 * which flips `machine_id` between undefined and the persisted value and
 * toggles the SocketDisplay `null` gate — remounting the socket and driving the
 * ~1 Hz REPLACE_STALE reconnect storm. Reading/seeding localStorage here
 * removes that race: the id is a single durable value, resolved before React
 * renders. Returns `null` only if localStorage is entirely unavailable.
 */
export const getOrCreateMachineID = (): string | null => {
  try {
    const existing = window.localStorage.getItem(MACHINE_ID_STORAGE_KEY)
    if (existing) {
      return existing
    }
    const generated = createUUID()
    window.localStorage.setItem(MACHINE_ID_STORAGE_KEY, generated)
    return generated
  } catch (e) {
    // localStorage unavailable (private mode / disabled). Fall back to the
    // redux-provided id handled by the caller.
    return null
  }
}

export const tryParseJSON = (jsonString:string) => {
  try {
    const o = JSON.parse(jsonString);
    if (o && typeof o === 'object') {
      return o
    }
  } catch (e) {}

  return false
}

export const is_superuser = (user:User) => {
  return user.role === 'SuperUser'
}

export function dynamicSort(property:string) {
  let sortOrder = 1
  if (property[0] === '-') {
    sortOrder = -1
    property = property.substr(1)
  }
  return function (a: { [x: string]: number; }, b: { [x: string]: number; }) {
    /* next line works with strings and numbers,
     * and you may want to customize it to your needs
     */
    const result =
      a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0
    return result * sortOrder
  }
}
